import { Translations } from './en';

const fr: Translations = {
  invitationSent: 'Vous avez invité un utilisateur',
  invitationDescription: '{{name}} a reçu une invitation à collaborer sur Wirk.',
  contributorInfo: 'Contributeur',
  metrics: 'Métriques',
  information: 'Informations',
  segments: 'Segments',
  certifications: 'Certifications',
  activity: 'Activité',
  export: 'Exporter',
  filter: 'Filtrer',
  workedHours: 'Temps effectif travaillé',
  numberOfProjects: 'Nombre de projets',
  volume: 'Volume',
  projectName: 'Nom du projet',
  lastTask: 'Dernière tâche',
  tasksCompleted: 'Tâches effectuées',
  pace: 'Cadence',
  effectiveTime: 'Temps effectif',
  distribution: 'Répartition',
  quality: 'Qualité',
  project: 'Projet',
  objective: 'Objectif',
  top20Percent: 'TOP 20%',
  averageCompletionTime: 'Temps moyen de réalisation',
  table: 'Tableau',
  skills: 'Compétences',
  periods: {
    lastDay: 'Dernier jour',
    last7Days: '7 derniers jours',
    lastMonth: 'Dernier mois',
    lastYear: 'Dernière année',
  },
  profile: {
    description: 'Ces informations seront affichées sur votre profil.',
    sections: {
      general: 'Général',
      socioDemographic: 'Socio-démographique',
      address: 'Adresse',
    },
    fields: {
      id: 'ID',
      birthDate: 'Date de naissance',
      nationality: 'Nationalité',
      earning: 'Niveau de revenu',
      study: 'Études',
      family: 'Situation familiale',
      children: 'Nombre d’enfants',
      job: 'Profession',
      activitySector: 'Secteur d’activité',
      address: 'Adresse',
      zipCode: 'Code postal',
      city: 'Ville',
      region: 'Région',
    },
    blacklist: {
      title: 'Projets blacklistés',
      project: 'Projet',
      tasks: 'Tâches',
      averageQuality: 'Qualité moyenne',
      exclusionDate: 'Date d’exclusion',
    },
  },
  delete: {
    title: 'Supprimer le contributeur',
    button: 'Supprimer',
    modal: {
      title: 'Supprimer le contributeur ?',
      label: 'Êtes-vous sûr de vouloir effectuer cette action ?',
    },
  },
};

export default fr;
